/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Coinvestments2Inputs */

const en_navtitles_coinvestments2 = /** @type {(inputs: Navtitles_Coinvestments2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-investments`)
};

/**
* | output |
* | --- |
* | "Co-investments" |
*
* @param {Navtitles_Coinvestments2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_coinvestments2 = /** @type {((inputs?: Navtitles_Coinvestments2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Coinvestments2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_coinvestments2(inputs)
});
export { navtitles_coinvestments2 as "navTitles_coInvestments" }